import React, { Component } from 'react';

import Menu from '../menu';
import NavigationBar from '../menu/NavigationBar';
import APICard from '../components/APICard';
import Parameter from '../components/Parameter';

class Dashboard extends Component {

    constructor(props) {
        super(props);

        this.state = {
            services: {
                one: {
                    id: 'one',
                    name: 'Transactions',
                    method: 'GET',
                    path: 'https://pos.avalue.co.th/api/transactions',
                    description: 'Filter transactions by date and limit',
                    parameters: [
                        {
                            name: "shopid",
                            defaultValue: "",
                            inputType: "text",
                            type: "String",
                            location: "query",
                            description: "Shop ID",
                            textInputType: "text"
                        },
                        {
                            name: "limit",
                            defaultValue: "",
                            inputType: "text",
                            type: "Number",
                            location: "query",
                            description: "(Optional) Limit number of transactions results. default is 50",
                            textInputType: "number"
                        },
                        {
                            name: "startAt",
                            defaultValue: "",
                            inputType: "text",
                            type: "Number",
                            location: "query",
                            description: "(Optional) Unix timestamp in seconds e.g., 1489648703",
                            textInputType: "number"
                        }
                    ]
                }
            }
        }
    }


    render() {
        const { services } = this.state;

        return (
            <div>
                <NavigationBar />

                <div className="explorer-api">
                    <div className="content-api">
                        <div className="row">
                            {/* <Menu 
                                
                            /> */}

                            <div className="col-lg-9 col-md-12 col-sm-12 detail-api">
                                <h4>A-POS</h4>
                                {/* <p className="box lead-detail">
                                    {`Computer users and programmers have become so accustomed to using Windows, even for the changing capabilities
                                    and the appearances of the graphical interface of the versions, therefore it has remained Microsoft’s
                                    product.`}
                                </p> */}
                                <div id="accordion">

                                    <APICard
                                        method="GET"
                                        name="Transactions"
                                        path="https://pos.avalue.co.th/api/transactions"
                                        description="Filter transactions by date and limit"
                                        id="one"
                                        config={services.one}
                                    />

                                    {/* <APICard
                                        method="DELETE"
                                        name="API Name"
                                        path="/near/location/sss"
                                        description="Simply dummy text of the printing and typesetting industry."
                                        id="three"
                                    /> */}


                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/views/dashboard/index.jsx